/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestsaccepted1Inputs */

const en_requestsaccepted1 = /** @type {(inputs: Requestsaccepted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const de_requestsaccepted1 = /** @type {(inputs: Requestsaccepted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angenommen`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Requestsaccepted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsaccepted1 = /** @type {((inputs?: Requestsaccepted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsaccepted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsaccepted1(inputs)
	return de_requestsaccepted1(inputs)
});
export { requestsaccepted1 as "requestsAccepted" }